import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        setStatus(data.payment_status);
        if (data.payment_status === "paid") return;
        if (tries >= 15) return;
        setTimeout(() => setTries((t) => t + 1), 2000);
      } catch {
        if (tries >= 15) return;
        setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sid, tries]);

  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="payment-success">
      <div className="border border-stone-200 bg-white p-8">
        <div className="w-16 h-16 bg-green-100 text-green-600 flex items-center justify-center mx-auto mb-4">
          <CheckCircle size={40} weight="fill" />
        </div>
        <h1 className="font-display text-3xl font-black tracking-tighter mb-2">
          {status === "paid" ? "Ödeme tamamlandı!" : "Ödeme işleniyor…"}
        </h1>
        <p className="text-stone-500 mb-6 text-sm">
          {status === "paid"
            ? "Teşekkürler! Kazandığınız açık artırma için ödeme başarıyla alındı."
            : "Stripe ödemenizi onayladıktan sonra bu sayfa güncellenecek."}
        </p>
        <Link to="/panelim" className="inline-block bg-stone-950 text-white px-6 py-3 font-bold hover:bg-stone-800 transition-colors">
          Panele Dön
        </Link>
      </div>
    </div>
  );
}
